import React, { useEffect, useState } from "react";

// CSS
import "./popupConfirmation.css";

// Components
import Button from "./button";
import InputField from "./inputField";

// Functions and hooks
import useClickOutside from "../../hooks/useClickOff";
import { useTranslation } from "react-i18next";

export default function PopupConfirmation({
  message,
  onConfirm,
  onCancel,
  style,
  highSecurity = false,
}) {
  const ref = useClickOutside(() => onCancel());
  const styles = ["info", "warning"];
  const styleFinal = styles.includes(style) ? style : styles[0];

  const [confirmEnabled, setConfirmEnabled] = useState(true);
  const [securityInput, setSecurityInput] = useState("");

  const isHighSecurityConfirmed = !highSecurity || securityInput === "CONFIRM";

  const { t } = useTranslation();

  const onConfirmLocal = () => {
    if (!isHighSecurityConfirmed) return;
    setConfirmEnabled(false);
    if (onConfirm) onConfirm();
  };

  useEffect(() => {
    setConfirmEnabled(true);
    setSecurityInput("");
  }, []);

  return (
    <div className="popup-overlay">
      <div className="popup-background"></div>
      <div ref={ref} className={"popup-container " + styleFinal}>
        <div className="popupConfMsg">{message}</div>

        {highSecurity && (
          <div className="popup-confirm-security">
            <p className="popup-confirmation-confirm-label">
              {t("Type/Write")} <strong>CONFIRM</strong> {t("to proceed.")}
            </p>
            <InputField
              value={securityInput}
              onChange={setSecurityInput}
              placeholder={t("Type CONFIRM")}
              type="text"
              className="w-100% mb-0 mt-2"
            />
          </div>
        )}

        <div className="popup-buttons">
          <Button
            btnMargin="btn-default"
            btnStyle={
              styleFinal === "warning" ? "btn-negative" : "btn-posit  ive"
            }
            onClick={onConfirmLocal}
            icon="apply"
            disabled={!confirmEnabled || !isHighSecurityConfirmed}
          >
            {t("OK")}
          </Button>
          <Button
            btnMargin="btn-default"
            btnStyle="btn-primary"
            onClick={onCancel}
          >
            {t("Cancel")}
          </Button>
        </div>
      </div>
    </div>
  );
}
